import { render, staticRenderFns } from "./InsConfirm.vue?vue&type=template&id=77248458&scoped=true"
import script from "./InsConfirm.vue?vue&type=script&lang=ts"
export * from "./InsConfirm.vue?vue&type=script&lang=ts"
import style0 from "./InsConfirm.vue?vue&type=style&index=0&id=77248458&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77248458",
  null
  
)

export default component.exports